import React, { useMemo } from 'react'
import { useParams} from 'react-router-dom'
import useCurrentNodeData from './useCurrentNodeData'
import PreviewCommonComponent from './Components/PreviewCommonComponent'

const CurrentNode = () => {
  const { audit_trail_id } = useParams()
  const previewData = useCurrentNodeData(audit_trail_id)
  return <>
    <PreviewCommonComponent previewData={previewData} audit_trail_id={audit_trail_id} />
  </>
}

export default CurrentNode